<template>
  <div>


    <div class="barcode-area">
      <div class="ba-wrap" id="barcodeArea">
        <div class="baw-title">
          <h2>바코드 확인</h2>
          <div><button v-on:click="barcodeClose"><i class="uil uil-times"></i></button></div>
        </div>
        <div class="baw-width">
          <p>
            <VueBarcode :value="barcodeValue" :options="{height:40,width:1, fontSize:15, textMargin: 10 }">
            </VueBarcode>
          </p>

        </div>
        <div class="baw-height">
          <p style="transform: rotate(90deg);">
            <VueBarcode :value="barcodeValue" :options="{height:100, width:3, fontSize:15, textMargin: 10}">
            </VueBarcode>
          </p>
        </div>
      </div>
    </div>
    <div class="barcode-bg" id="barcodeBg" v-on:click="barcodeClose">&nbsp;</div>


  </div>
</template>

<script>

import VueBarcode from '@chenfengyuan/vue-barcode';

export default {
  name: "Barcode",
  components: {
    VueBarcode
  },
  data: () => ({
    barcodeValue : ''
  }),
  created() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.barcodeValue = userInfo.user_no
  },
  methods: {
    barcodeClose: function () {
      document.getElementById("barcodeArea").style.right = "-250px";
      document.getElementById("barcodeBg").style.display = "none";
    },
  },
};
</script>